import { Moment } from 'moment'

export type formatTypes =
  | 'FORMAT_DATE_API'
  | 'FORMAT_TIME_API'
  | 'FORMAT_DATE_FULL'
  | 'FORMAT_DATE_EXTRA_SHORT'
  | 'FORMAT_DATE_SHORT'
  | 'FORMAT_DATE_MEDIUM'
  | 'FORMAT_DATE_LONG'
  | 'FORMAT_FULL_DATE_API'
  | 'FORMAT_TIME_SHORT'

export const formatDate = (
  date: Moment,
  format: formatTypes,
  locale?: string,
) => {
  switch (format) {
    case 'FORMAT_DATE_API':
      return date.clone().format('YYYY-MM-DD')
    case 'FORMAT_TIME_API':
      return date.clone().format('HH:mm:ss')
    case 'FORMAT_TIME_SHORT':
      return date.clone().format('HH:mm')
    case 'FORMAT_FULL_DATE_API':
      return date.clone().format('YYYY-MM-DD HH:mm:ss')
    case 'FORMAT_DATE_EXTRA_SHORT':
      return date.clone().format('dd Do')
    case 'FORMAT_DATE_SHORT':
      return date.clone().format('DD/MM/YYYY')
    case 'FORMAT_DATE_MEDIUM':
      return date.clone().format('D MMM YYYY')
    case 'FORMAT_DATE_LONG':
      return date.clone().format('D MMMM YYYY')
    case 'FORMAT_DATE_FULL':
    default:
      return date.clone().format('dddd D MMMM YYYY')
  }
}
